import { createAxios } from '../lib/axiosFactory';
import { errorParser } from '../lib/response/errorParser';
import { ActionResponse } from '../lib/interfaces/actionResponse';
import { dataCollectionParser } from '../lib/response/dataParser';
import { Pages } from '../lib/enums/pages';
function getState() {
  return {
    totalCount: null,
    historyList: [],
    prevPages: [],
    currentPage: {},
    nextPages: []
  };
}

export const state = getState();

export const mutations = {
  setList(state: any, list: any[]): void {
    state.historyList = list;
  },
  setTotalCount(state: any, count: number): void {
    state.totalCount = count;
  },
  setPages(state: any, pageLinks: any): void {
    state.prevPages = pageLinks.previousPages;
    state.currentPage = pageLinks.currentPage;
    state.nextPages = pageLinks.nextPages;
  }
};

export const getters = {};

export const actions = {
  async loadContactUploadHistory(
    { commit, rootState },
    { endpoint }: { endpoint?: string } = {}
  ) {
    try {
      let response;
      if (endpoint) {
        response = await createAxios().get(endpoint);
      } else {
        const defaultEndpoint = '/backend/contact-upload-histories-index';
        const params = {
          'page[limit]': rootState.user.pageSizes[Pages.ImportHistory] || 25
        };
        response = await createAxios().get(defaultEndpoint, { params });
      }

      const { links, meta } = response.data;
      commit('setList', dataCollectionParser(response));
      commit('setTotalCount', meta.contactUploadsCount);
      commit('setPages', links);

      return { success: true, errors: {}, body: response.data };
    } catch (error) {
      commit('setList', []);
    }
  }
};
